import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

import { PopupDialogAction, PopupDialogActionOptions } from '../models/popup-dialog-object';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable({
	providedIn: 'root'
})
export class ExcelGenerateErrorHandlerService extends AbstractErrorHandlerService {
	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error: any): void {
		const errorCodesToHandle = Object.values(ERROR_CODES.EXCEL_GENERATE_ERROR_CODES);
		const errorJson = this.getErrorJson(error);

		if (errorCodesToHandle.includes(get(errorJson, 'errorCode'))) {
			const errorTitle = this.contentService.get('SOMETHING_WRONG_ERROR_TITLE', ErrorDCR.SOMETHING_WRONG_ERROR_TITLE);
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = 'unabletoprocessrequest';

			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			this.errorMessage = this.contentService.get('EXCEL_GENERATE_ERROR_MESSAGE', ErrorDCR.EXCEL_GENERATE_ERROR_MESSAGE);

			const actions = [
				PopupDialogAction.create({
					label: this.contentService.get('ERROR_CONTINUE_LABEL', 'Continue'),
					type: 'continue',
					reload: false
				} as PopupDialogActionOptions)
			];

			console.error(this.errorMessage, error);
			this.errorPopupService.openResponseMessageDialog(
				this.buildErrorMessage(false, 'error-excel-dialog', errorTitle, this.trackErrorMessage, this.errorMessage, true, [], actions)
			);

		} else {
			this.nextHandler.handleError(error);
		}
	}

	private getErrorJson(error: any): any {
		try {
			return JSON.parse(get(error, 'message'));
		} catch {
			return {};
		}
	}
}
